import request from '@/utils/http';

// 主页列表数据
export const getSearchList = (data) => {
    return request({
        url: `/api-antms/query/dispatchInspection/queryByPage`,
        method: 'post',
        data
    });
};
// 一车一检-列表分页统计数量
export const queryCount = (data) => {
    return request({
        url: '/api-antms/query/dispatchInspection/queryCount',
        method: 'post',
        data
    });
};
// 明细数据接口
export const getDetailList = (params) => {
    return request({
        url: `/api-mobile/vehicle/inspectionDetail/list`,
        method: 'get',
        params
    });
};

// 同意
export const pictureApprove = (data) => {
    return request({
        url: `/api-antms/data/dispatchInspection/pictureApprove`,
        method: 'post',
        data
    });
};

// 调整审批人-批量
export const batchAdjustApprove = (data) => {
    return request({
        url: `/api-antms/data/dispatchInspection/batchAdjustApprove`,
        method: 'post',
        data
    });
};
